import React from 'react';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";

const Horario = ({ mt15, horario, horarios }) => {

    return (
        <>
            <Col style={mt15} xs={isBrowser ? 4 : 12}>
                <strong> { horarios.find(x => x.id === horario.horarioTipoId)?.nombre }, </strong> 
                <strong> disponibilidad:  </strong> <br/> 
                    Lunes a Viernes {horario.trabajaDiasSemana == 1 ? '(Sí)' : '(No)'} <br/> 
                    Sábado {horario.trabajaSabado == 1 ? '(Sí)' : '(No)'}  <br/> 
                    Domingo {horario.trabajaDomingo == 1 ? '(Sí)' : '(No)'} 
            </Col>

        </>
    );
};

export default (Horario);